import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import BaselineTable from "./BaselineTable";
import { TableContext } from "../../index";
import { debug } from "../../utils";


function BaselineTableSection(deviceId) {

    const history = useHistory();

    const initTableConfig = {
        selected: []
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            <div className="container-fluid" key={history.location}>
                <div className="row">
                    <div className="col-12">
                        <div className="card oct_table-card">
                            {/* <BaselineTableHeader/> */}
                            <div className="card-body">
                                <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <BaselineTable />
                                            {/* <PaginationManager getPage={baselineSevice.listPageable} /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TableContext.Provider>
    )
}

export default BaselineTableSection;
